import type React from "react";
import {BrowserRouter} from "react-router-dom";

import {OrthographicCamera} from "@react-three/drei";

import BackgroundImage from "~/component/common/BackgroundImage";
import BackgroundMusic from "~/component/common/BackgroundMusic";
import {CameraUpdater} from "~/contexts/camera/CameraUpdater";
import {UniformsProvider} from "~/contexts/uniforms/UniformsProvider";

import GameObjects from "../three/main/GameObjects";
import MyCanvas from "../three/main/MyCanvas";
import HtmlRoutes from "./HtmlRoutes";
import Routes from "./Routes";

const Layout: React.FC = () => {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen text-white h-screen w-screen">
        <div className="flex-1 overflow-auto">
          <MyCanvas>
            <UniformsProvider>
              <CameraUpdater />
              <OrthographicCamera
                position={[0, 0, 100]}
                makeDefault
                zoom={100}
              />
              <GameObjects />
              <Routes />
            </UniformsProvider>
            {/*<StatsGl className={"absolute top-0 left-0"}/>*/}
          </MyCanvas>
          <BackgroundMusic />
          <BackgroundImage />
          <HtmlRoutes />
        </div>
      </div>
    </BrowserRouter>
  );
};

export default Layout;
